import React from "react";

const ContentBulkUploadIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.441"
      height="17.543"
      viewBox="0 0 21.441 17.543"
    >
      <g id="upld_frm_fldr" transform="translate(-2 -6)">
        <path
          id="Path_1211"
          data-name="Path 1211"
          d="M15.157,6a1.973,1.973,0,0,0-1.808,1.189l-.124.286H5.411A1.956,1.956,0,0,0,3.462,9.424v.482A1.536,1.536,0,0,0,2,11.43V21.594a1.956,1.956,0,0,0,1.949,1.949H17.342a.869.869,0,0,0,.189-.028,5.36,5.36,0,1,1,5.847-6.108.474.474,0,0,0,.063-.226V7.949A1.956,1.956,0,0,0,21.492,6ZM5.411,8.449H12.8l-.34.785a1.1,1.1,0,0,1-1.012.664H4.437V9.424a.962.962,0,0,1,.975-.975ZM18.081,13.8a4.386,4.386,0,1,0,4.386,4.386A4.378,4.378,0,0,0,18.081,13.8Zm0,1.466a.476.476,0,0,1,.345.139l1.462,1.462a.487.487,0,1,1-.689.689l-.63-.63v3.7a.487.487,0,1,1-.975,0v-3.7l-.63.63a.487.487,0,1,1-.689-.689L17.737,15.4a.476.476,0,0,1,.345-.139Z"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default ContentBulkUploadIcon;
